import { MyLatestSubscriptionStatus, ProductFamilyType, SubscriptionState } from '../../../gql/globalTypes';
import { LegacyCatalogItemType, LegacyProductFamily, LegacySubscriptionStatus } from '../interface/LegacyMyLatestSubscriptionsWithDates';
/**
 * Map to Legacy Subscription Status value from Vendor Subscription status value
 * @param MyLatestSubscriptionV1WithDates | MyLatestSubscriptionV1WithStatus | null
 * @returns Legacy Subscription status
 */
export var legacySubscriptionStatus = function legacySubscriptionStatus(latestSubscription) {
  var _ref = latestSubscription || {},
    myLatestSubscriptionStatus = _ref.myLatestSubscriptionStatus,
    subscription = _ref.subscription;
  if (!subscription) {
    return null;
  }
  var state = subscription.state;
  switch (state) {
    case 'ACTIVE':
      {
        if (myLatestSubscriptionStatus == MyLatestSubscriptionStatus.ACTIVE_END_OF_BILLING_CYCLE) {
          return LegacySubscriptionStatus.PENDING_PAUSE;
        } else {
          return LegacySubscriptionStatus.ACTIVE;
        }
      }
    case 'CANCELLED':
      return LegacySubscriptionStatus.PENDING_CANCEL;
    case 'EXPIRED':
      return LegacySubscriptionStatus.CANCELLED;
    case 'PAUSED':
      return LegacySubscriptionStatus.PAUSED;
    default:
      return null;
  }
};

/**
 * Map to Legacy catalog item type value from Vendor catalog item type value
 * @param MyLatestSubscriptionV1WithDates | MyLatestSubscriptionV1WithStatus | null
 * @returns
 */
export var legacyCatalogItemType = function legacyCatalogItemType(latestSubscription) {
  var _ref2 = latestSubscription || {},
    subscription = _ref2.subscription,
    productFamilyType = _ref2.productFamilyType;
  if (!subscription) {
    return null;
  }
  var cheggPlan = subscription.cheggPlan,
    vendorPlan = subscription.vendorPlan;
  if (cheggPlan !== null && cheggPlan !== void 0 && cheggPlan.type) {
    return cheggPlan.type;
  }
  var _ref3 = vendorPlan || {},
    billingType = _ref3.billingType;
  if (billingType == 'ONE_TIME') {
    return LegacyCatalogItemType.ONE_TIME;
  }
  if (billingType == 'RECURRING') {
    if (productFamilyType == 'CHEGG_STUDY_PACK') {
      return LegacyCatalogItemType.RECURRING_BUNDLE_ITEM;
    } else {
      return LegacyCatalogItemType.FIXED_RECURRING_ITEM;
    }
  }
  return null;
};

/**
 * Map to Legacy productFamily value from Vendor productFamily value
 * @param MyLatestSubscriptionV1WithDates | MyLatestSubscriptionV1WithStatus | null
 * @returns
 */
export var legacyProductFamily = function legacyProductFamily(latestSubscription) {
  var _ref4 = latestSubscription || {},
    productFamilyType = _ref4.productFamilyType,
    subscription = _ref4.subscription;
  if (!subscription) {
    return null;
  }
  var cheggPlan = subscription.cheggPlan,
    vendorPlan = subscription.vendorPlan;
  if (cheggPlan !== null && cheggPlan !== void 0 && cheggPlan.type) {
    return cheggPlan.familyId;
  }
  var _ref5 = vendorPlan || {},
    billingType = _ref5.billingType,
    family = _ref5.family;
  if (billingType == 'ONE_TIME' && family) {
    return family.toUpperCase();
  }
  if (billingType == 'RECURRING' && family) {
    if (productFamilyType == 'CHEGG_STUDY_PACK') {
      return LegacyProductFamily.CHEGG_STUDY_PACK;
    } else if (productFamilyType == ProductFamilyType.CHEGG_STUDY) {
      return LegacyProductFamily.CHEGG_STUDY;
    }
    return null;
  }
  return null;
};

/**
 * Map to offerId value from vendorPlan or cheggPlan
 * @param MyLatestSubscriptionV1WithDates | MyLatestSubscriptionV1WithStatus | null
 * @returns
 */
export var getOfferIds = function getOfferIds(latestSubscription) {
  var _ref6 = latestSubscription || {},
    subscription = _ref6.subscription;
  if (!subscription) {
    return null;
  }
  var cheggPlan = subscription.cheggPlan,
    vendorPlan = subscription.vendorPlan;
  if (cheggPlan !== null && cheggPlan !== void 0 && cheggPlan.type) {
    return cheggPlan.entitlements || null;
  } else if (vendorPlan !== null && vendorPlan !== void 0 && vendorPlan.billingType) {
    return vendorPlan.entitlements || null;
  }
  return null;
};

/**
 * Map to productId value from vendorPlan or cheggPlan
 * @param MyLatestSubscriptionV1WithDates | MyLatestSubscriptionV1WithStatus | null
 * @returns
 */
export var getProductId = function getProductId(latestSubscription) {
  var _ref7 = latestSubscription || {},
    subscription = _ref7.subscription;
  if (!subscription) {
    return null;
  }
  var cheggPlan = subscription.cheggPlan,
    vendorPlan = subscription.vendorPlan;
  if (cheggPlan !== null && cheggPlan !== void 0 && cheggPlan.id) {
    return cheggPlan.id;
  } else if (vendorPlan !== null && vendorPlan !== void 0 && vendorPlan.id) {
    return vendorPlan.code;
  }
  return null;
};

/**
 * Map to Legacy renewalDate value from subscription response value
 * @param MyLatestSubscriptionV1WithDates | null
 * @returns
 */
export var legacyRenewalDate = function legacyRenewalDate(latestSubscription) {
  var _ref8 = latestSubscription || {},
    subscription = _ref8.subscription;
  if (!subscription) {
    return null;
  }
  var state = subscription.state,
    resumeAt = subscription.resumeAt,
    renewalAt = subscription.renewalAt,
    expirationAt = subscription.expirationAt;
  if (legacyCatalogItemType(latestSubscription) == LegacyCatalogItemType.ONE_TIME) {
    return null;
  } else {
    switch (state) {
      case SubscriptionState.ACTIVE:
        return renewalAt;
      case SubscriptionState.CANCELLED:
        return expirationAt;
      case SubscriptionState.PAUSED:
        return resumeAt;
      default:
        return null;
    }
  }
};

/**
 * Map to Legacy accessExpirationDate value from subscription response value
 * @param MyLatestSubscriptionV1WithDates | null
 * @returns
 */
export var legacyAccessExpirationDate = function legacyAccessExpirationDate(latestSubscription) {
  var _ref9 = latestSubscription || {},
    subscription = _ref9.subscription;
  if (!subscription) {
    return null;
  }
  var state = subscription.state,
    expiredAt = subscription.expiredAt,
    expirationAt = subscription.expirationAt,
    renewalAt = subscription.renewalAt,
    pausedAt = subscription.pausedAt,
    targetPauseAt = subscription.targetPauseAt;
  if (legacyCatalogItemType(latestSubscription) == LegacyCatalogItemType.ONE_TIME) {
    switch (state) {
      case SubscriptionState.ACTIVE:
        return expirationAt;
      default:
        return expiredAt;
    }
  } else {
    switch (state) {
      case SubscriptionState.ACTIVE:
        return expirationAt || targetPauseAt || renewalAt;
      case SubscriptionState.CANCELLED:
        return expirationAt;
      case SubscriptionState.PAUSED:
        return pausedAt;
      case SubscriptionState.EXPIRED:
        return expiredAt;
      default:
        return null;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/SubscriptionUtil/legacy/LegacySubscriptionHelpers.js
// module id = 870
// module chunks = 11